// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { attributesSpecificationsSectionStyles } from "@pace/App/Components/ProductDetails/AttributesSpecificationsSection";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

attributesSpecificationsSectionStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
};

attributesSpecificationsSectionStyles.section = {
    css: css`
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        gap: 22px;
        overflow: hidden;
        @media print {
            overflow: visible;
        }
        ${({ hasDivider }: any) =>
            hasDivider &&
            css`
                padding-bottom: 20px;
                border-bottom: 1px solid ${color("common.ui12")};
            `}
    `,
};

attributesSpecificationsSectionStyles.table = {
    css: css`
        td {
            padding: 8px 12px;
        }
    `,
};
attributesSpecificationsSectionStyles.tableContainer = {
    css: css`
        display: flex;
        flex-basis: 450px;
        @media print {
            flex: 1;
        }

        ${xScreen("lt", "sm")} {
            flex-basis: 100%;
            max-width: 100%;
        }
    `,
};

attributesSpecificationsSectionStyles.valueCell = {
    css: css`
        text-wrap: wrap;
    `,
};

attributesSpecificationsSectionStyles.label = {
    weight: fontConfig.weight.bold,
    css: css`
        &&&& {
            font-size: 12px;
            line-height: 13px;
        }
    `,
};

attributesSpecificationsSectionStyles.value = {
    css: css`
        &&&& {
            font-size: 12px;
            line-height: 13px;
            white-space: normal;
        }
    `,
};
